export default __webpack_public_path__ + "static/media/virtualjpeg.b7e07d29.webp";